var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('h1',{staticClass:"text-center"},[_vm._v("404")])])
}]

export { render, staticRenderFns }